import { createFileRoute } from '@tanstack/react-router'
import { internshipProgramSearchSchema } from '@/features/programs/filter-internship-program/model/internshipProgramSearch'
import { InternshipProgramPage } from '@/pages/internship-program/ui/InternshipProgramPage'

export const Route = createFileRoute('/my-program')({
  validateSearch: internshipProgramSearchSchema,
  component: InternshipProgramPage,
})
